
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _2257a6fgGNSxKLDvKiUy7AgFo0Gu8VWRvl2NwrcIJFjmLBUMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/2257.vue?macro=true";
import { default as dmca_45bF2gTxUUnOLl9Cny1t9LPQ7FEY5uk9VmZS_45le_458JlYMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/dmca.vue?macro=true";
import { default as joinZDmQtdxp_jOdlMzXAw_k1o6naS905bNtcEnChXRnQ7gMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/join.vue?macro=true";
import { default as indexo3mJVS8__Tz1g_VJtdrUSsvgqJ5WDouOcgrRaR_45uKGcMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/index.vue?macro=true";
import { default as loginWQhhR9CnTq6CUwOBpx5pUTq7zsgPtYJ7e8Lpw2MnW_wMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/login.vue?macro=true";
import { default as mediaht82oWJY3mh2zVfFFRnAoHA91pmTyTurrDr52C2QXNMMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/media.vue?macro=true";
import { default as healthKZeiHostcnwLJ6G4jV1B_ySZSVDP0hfUpq_45h57WwzbYMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/health.vue?macro=true";
import { default as walletQJ_45NkbR7uyOkDsVPfTQIQYtQnohEpVb1Ut7fRcJXPdYMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/wallet.vue?macro=true";
import { default as privacyOqzhAiTtCKxSTWbFn1d9wtyNS2eNuqQSlh5iP33zWTYMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/privacy.vue?macro=true";
import { default as calendarRdQnrwTfZdxu_45x5xRm6gQEll_45DnpKI_45caHCLEoEt1UUMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/calendar.vue?macro=true";
import { default as settingsA9OeHO3jmdv_erraWmv6DFF4_45Eh8XS96rq7VIcXydqYMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/settings.vue?macro=true";
import { default as favoritesji_45Wz_vDKuUbEJEHEi22yXQ1cBB8K9RP3tqZcvFnIPMMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/favorites.vue?macro=true";
import { default as purchasesmOxqjdaBT1rQQCYY9wgX2qGkbdU9UMYXZoC6HaZHfOcMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/purchases.vue?macro=true";
import { default as creatorsf31XWJhbZhsAQzp5uGZVQWuo4i5utB6I6XREt09uQtEMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/l/creators.vue?macro=true";
import { default as statementsODi22MYOwPf3RXxaNsfTpwYGojXvOKuNcZqTf1N22vAMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/statements.vue?macro=true";
import { default as maintenanceCA2FvBAXg3kB17K4r7csMUKW4Ph_45FJCemITwvaSc8FQMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/maintenance.vue?macro=true";
import { default as indexuGH3ZTQ6_45voQq_45vIbuvJdxEFizPB_45zNEH7CYDSgPfiwMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/[slug]/index.vue?macro=true";
import { default as cookie_45noticeCJENX5HfMZyeAYMe8DWrH7FaHGj4LEgTXEJK1KX_45jzkMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/cookie-notice.vue?macro=true";
import { default as notificationsMbca6EaMbAEzvQ40Imy8PW2uJeFwZ9CeExocEOaw100Meta } from "/home/runner/work/favoritely/favoritely/frontend/pages/notifications.vue?macro=true";
import { default as index_457iKJOMukHO9gF0FawddhAZnZYCzql2C0pH13fzmn38Meta } from "/home/runner/work/favoritely/favoritely/frontend/pages/stories/index.vue?macro=true";
import { default as reset_45passwordkxfbLlU6OjqqdrXmhLKF80IcNnp_Rz_nRxDs_45oHG7VcMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/reset-password.vue?macro=true";
import { default as createg5V_X392H2Lv7GUbNJsTlazS_9OvATIUF4VhbhMDGpAMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/stories/create.vue?macro=true";
import { default as billing_45support2RiRJ57dbwBJKKI6agTmg8U6NVqlItnsQF_45NlA97PpYMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/billing-support.vue?macro=true";
import { default as content_45removal2_H1WJ5lTgYmS6jvrBruBD_45O5nhuKbXJmXTPIH6Y15gMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/content-removal.vue?macro=true";
import { default as email_45confirmedq_cPRXYmIpGASoyj3m_452XROMI6eaWF2wLkVDlx0w1ucMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/email-confirmed.vue?macro=true";
import { default as forgot_45password_ENWR_ZlEECnCm2p5sD0TCDqNBhjBnCP76Aksv0Y68kMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/forgot-password.vue?macro=true";
import { default as terms_45for_45usersDrsl7_45OibdAxJAodtBdZIx36gDmo9dbjApszaV7OnRAMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/terms-for-users.vue?macro=true";
import { default as anti_45spam_45policy_ZEDDgOcvRdxzabumW1DbBmKMNAii0O6Ey2lbwKvhuAMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/anti-spam-policy.vue?macro=true";
import { default as _91id_939A7apK_7YxawG6a3h7yF3QazfCdNhFp5lOqAeumMYwkMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/[slug]/posts/[id].vue?macro=true";
import { default as editd52QliLpzZxgjGO_nUXnb8IHzHezXTBzsIq2_45oi21yAMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/stories/[id]/edit.vue?macro=true";
import { default as viewlUzhH9CLCK6YDvsfSOWvfkItg5fOvOll_45h7Sga9UHOsMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/stories/[id]/view.vue?macro=true";
import { default as terms_45for_45creatorsLA41yyvZPaKygrZSTRBUppTtqI8tjVssrl_9OZOhOm4Meta } from "/home/runner/work/favoritely/favoritely/frontend/pages/terms-for-creators.vue?macro=true";
import { default as community_45standardswExBNtCKtlnum_zcOICJbmhkc_45o9cmJo_yRtlW6j5qYMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/community-standards.vue?macro=true";
import { default as index1i_45_454DayoahvClLvOSSLlPLBAKFwbuU_45yG7qwaPwXoAMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/account/holding/index.vue?macro=true";
import { default as analytics_45and_45reportsyhgBLsjxcxYPogoEX24iTanuP9UqXaLmcNDVqe2g35QMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/analytics-and-reports.vue?macro=true";
import { default as _91_91username_93_93RJnX8vv0UhZZeKwxRLVWZWufmNiihc6bzcnHZzznhT4Meta } from "/home/runner/work/favoritely/favoritely/frontend/pages/messages/[[username]].vue?macro=true";
import { default as callbackedld8BRXzHs3aRMtg_45p0D6kxQkmZbbTRnnfS_45I85OqkMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/oauth/discord/callback.vue?macro=true";
import { default as general_45terms_45of_45servicecL4mHJycsibwFttXioyeMtak0ftstd9uQxHd4fk5riYMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/general-terms-of-service.vue?macro=true";
import { default as california_45privacy_45noticeWG210pp_45opsbPyv1WmSO5BXj3jPGJmi8yfi8pmvCuhgMeta } from "/home/runner/work/favoritely/favoritely/frontend/pages/california-privacy-notice.vue?macro=true";
import { default as callbackmRCfboWbdoealMF8dGb8XlhKVYvmf64KLYVUj2rb9k0Meta } from "/home/runner/work/favoritely/favoritely/frontend/pages/oauth/[provider]/callback.vue?macro=true";
export default [
  {
    name: "2257",
    path: "/2257",
    meta: _2257a6fgGNSxKLDvKiUy7AgFo0Gu8VWRvl2NwrcIJFjmLBUMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/2257.vue")
  },
  {
    name: "dmca",
    path: "/dmca",
    meta: dmca_45bF2gTxUUnOLl9Cny1t9LPQ7FEY5uk9VmZS_45le_458JlYMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/dmca.vue")
  },
  {
    name: "join",
    path: "/join",
    meta: joinZDmQtdxp_jOdlMzXAw_k1o6naS905bNtcEnChXRnQ7gMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/join.vue")
  },
  {
    name: "home",
    path: "/",
    meta: indexo3mJVS8__Tz1g_VJtdrUSsvgqJ5WDouOcgrRaR_45uKGcMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/login.vue")
  },
  {
    name: "media",
    path: "/media",
    meta: mediaht82oWJY3mh2zVfFFRnAoHA91pmTyTurrDr52C2QXNMMeta || {},
    alias: ["/media/review/:id?"],
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/media.vue")
  },
  {
    name: "health",
    path: "/health",
    meta: healthKZeiHostcnwLJ6G4jV1B_ySZSVDP0hfUpq_45h57WwzbYMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/health.vue")
  },
  {
    name: "wallet",
    path: "/wallet",
    meta: walletQJ_45NkbR7uyOkDsVPfTQIQYtQnohEpVb1Ut7fRcJXPdYMeta || {},
    alias: ["/wallet/:slug?"],
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/wallet.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacyOqzhAiTtCKxSTWbFn1d9wtyNS2eNuqQSlh5iP33zWTYMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/privacy.vue")
  },
  {
    name: "calendar",
    path: "/calendar",
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/calendar.vue")
  },
  {
    name: "settings",
    path: "/settings/:section?",
    meta: settingsA9OeHO3jmdv_erraWmv6DFF4_45Eh8XS96rq7VIcXydqYMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/settings.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    meta: favoritesji_45Wz_vDKuUbEJEHEi22yXQ1cBB8K9RP3tqZcvFnIPMMeta || {},
    alias: ["/favorites/:slug?"],
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/favorites.vue")
  },
  {
    name: "purchases",
    path: "/purchases",
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/purchases.vue")
  },
  {
    name: "l-creators",
    path: "/l/creators",
    meta: creatorsf31XWJhbZhsAQzp5uGZVQWuo4i5utB6I6XREt09uQtEMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/l/creators.vue")
  },
  {
    name: "statements",
    path: "/statements",
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/statements.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: maintenanceCA2FvBAXg3kB17K4r7csMUKW4Ph_45FJCemITwvaSc8FQMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/maintenance.vue")
  },
  {
    name: "profile",
    path: "/:slug()",
    meta: indexuGH3ZTQ6_45voQq_45vIbuvJdxEFizPB_45zNEH7CYDSgPfiwMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/[slug]/index.vue")
  },
  {
    name: "cookie-notice",
    path: "/cookie-notice",
    meta: cookie_45noticeCJENX5HfMZyeAYMe8DWrH7FaHGj4LEgTXEJK1KX_45jzkMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/cookie-notice.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/notifications.vue")
  },
  {
    name: "stories",
    path: "/stories",
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/stories/index.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordkxfbLlU6OjqqdrXmhLKF80IcNnp_Rz_nRxDs_45oHG7VcMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/reset-password.vue")
  },
  {
    name: "stories-create",
    path: "/stories/create",
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/stories/create.vue")
  },
  {
    name: "billing-support",
    path: "/billing-support",
    meta: billing_45support2RiRJ57dbwBJKKI6agTmg8U6NVqlItnsQF_45NlA97PpYMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/billing-support.vue")
  },
  {
    name: "content-removal",
    path: "/content-removal",
    meta: content_45removal2_H1WJ5lTgYmS6jvrBruBD_45O5nhuKbXJmXTPIH6Y15gMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/content-removal.vue")
  },
  {
    name: "email-confirmed",
    path: "/email-confirmed",
    meta: email_45confirmedq_cPRXYmIpGASoyj3m_452XROMI6eaWF2wLkVDlx0w1ucMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/email-confirmed.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45password_ENWR_ZlEECnCm2p5sD0TCDqNBhjBnCP76Aksv0Y68kMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/forgot-password.vue")
  },
  {
    name: "terms-for-users",
    path: "/terms-for-users",
    meta: terms_45for_45usersDrsl7_45OibdAxJAodtBdZIx36gDmo9dbjApszaV7OnRAMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/terms-for-users.vue")
  },
  {
    name: "anti-spam-policy",
    path: "/anti-spam-policy",
    meta: anti_45spam_45policy_ZEDDgOcvRdxzabumW1DbBmKMNAii0O6Ey2lbwKvhuAMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/anti-spam-policy.vue")
  },
  {
    name: "slug-posts-id",
    path: "/:slug()/posts/:id()",
    meta: _91id_939A7apK_7YxawG6a3h7yF3QazfCdNhFp5lOqAeumMYwkMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/[slug]/posts/[id].vue")
  },
  {
    name: "stories-id-edit",
    path: "/stories/:id()/edit",
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/stories/[id]/edit.vue")
  },
  {
    name: "stories-id-view",
    path: "/stories/:id()/view",
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/stories/[id]/view.vue")
  },
  {
    name: "terms-for-creators",
    path: "/terms-for-creators",
    meta: terms_45for_45creatorsLA41yyvZPaKygrZSTRBUppTtqI8tjVssrl_9OZOhOm4Meta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/terms-for-creators.vue")
  },
  {
    name: "community-standards",
    path: "/community-standards",
    meta: community_45standardswExBNtCKtlnum_zcOICJbmhkc_45o9cmJo_yRtlW6j5qYMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/community-standards.vue")
  },
  {
    name: "account-holding",
    path: "/account/holding",
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/account/holding/index.vue")
  },
  {
    name: "analytics-and-reports",
    path: "/analytics-and-reports/:section?/:filter?/:subfilter?",
    meta: analytics_45and_45reportsyhgBLsjxcxYPogoEX24iTanuP9UqXaLmcNDVqe2g35QMeta || {},
    alias: ["/reports/:section?/:filter?/:subfilter?","/analytics/:section?/:filter?/:subfilter?"],
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/analytics-and-reports.vue")
  },
  {
    name: "messages-username",
    path: "/messages/:username?",
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/messages/[[username]].vue")
  },
  {
    name: "oauth-discord-callback",
    path: "/oauth/discord/callback",
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/oauth/discord/callback.vue")
  },
  {
    name: "general-terms-of-service",
    path: "/general-terms-of-service",
    meta: general_45terms_45of_45servicecL4mHJycsibwFttXioyeMtak0ftstd9uQxHd4fk5riYMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/general-terms-of-service.vue")
  },
  {
    name: "california-privacy-notice",
    path: "/california-privacy-notice",
    meta: california_45privacy_45noticeWG210pp_45opsbPyv1WmSO5BXj3jPGJmi8yfi8pmvCuhgMeta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/california-privacy-notice.vue")
  },
  {
    name: "oauth-provider-callback",
    path: "/oauth/:provider()/callback",
    meta: callbackmRCfboWbdoealMF8dGb8XlhKVYvmf64KLYVUj2rb9k0Meta || {},
    component: () => import("/home/runner/work/favoritely/favoritely/frontend/pages/oauth/[provider]/callback.vue")
  }
]